export default "__VITE_ASSET__653a33ea__"